// function equalizeHeights(){let e=document.querySelectorAll(".testimonial-slide-inner"),t=0;e.forEach(e=>{e.style.height="auto",t=Math.max(t,e.offsetHeight)}),e.forEach(e=>{e.style.height=t+"px"})}document.addEventListener("DOMContentLoaded",()=>{let e=document.querySelectorAll(".testimonial-slider");e.forEach((e,t)=>{let i=e.querySelector(".slider-content"),r=e.querySelectorAll(".testimonial-slide"),n=e.querySelector("button.slider-arrow.left-arrow"),l=e.querySelector("button.slider-arrow.right-arrow"),a=0,o=window.innerWidth<=768?1:2,s=r.length,d=r[0].getBoundingClientRect().width,u=e.getAttribute("data-autoplay"),c=parseInt(e.getAttribute("data-speed"))||3e3,h;i.style.transition="none";let $=()=>{i.style.transform=`translateX(-${a*d}px)`},g=()=>{a<s-o?a++:a=0,$()},y=()=>{a>0?a--:a=s-o,$()},f=()=>{h=setInterval(g,c)},q=()=>{clearInterval(h)};"true"===u&&f(),l&&l.addEventListener("click",()=>{q(),g(),"true"===u&&setTimeout(f,300)}),n&&n.addEventListener("click",()=>{q(),y(),"true"===u&&setTimeout(f,300)});let E=()=>{o=window.innerWidth<=768?1:2,d=r[0].getBoundingClientRect().width,$()};window.addEventListener("resize",E),setTimeout(()=>{$(),i.style.transition="transform 0.5s ease-in-out",E()},50)})}),window.addEventListener("load",equalizeHeights),window.addEventListener("resize",equalizeHeights);
function initTestimonialSlider() {
  const $sliderWrapper = $('.testimonial-slider');
  const $slider = $sliderWrapper.find('.slider-content');

  // Get data attributes from the wrapper
  const autoplay = $sliderWrapper.data('autoplay') === true || $sliderWrapper.data('autoplay') === 'true';
  const speed = parseInt($sliderWrapper.data('speed')) || 3000;

  // Destroy slick if already initialized
  if ($slider.hasClass('slick-initialized')) {
    $slider.slick('unslick');
  }

  // Initialize slick with responsive settings and dynamic autoplay/speed
  $slider.slick({
    infinite: true,
    slidesToShow: 2,
    slidesToScroll: 1,
    autoplay: autoplay,
    autoplaySpeed: speed,
    autoplay: autoplay,
autoplaySpeed: speed,
centerMode: true,
centerPadding: '170px', 
    prevArrow: '<div class="slick-prev"><svg class="icon--icon-prev" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="m4 10l9 9l1.4-1.5L7 10l7.4-7.5L13 1z"/></svg></div>',
    nextArrow: '<div class="slick-next"><svg class="icon--icon-next" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20"><path fill="currentColor" d="M7 1L5.6 2.5L13 10l-7.4 7.5L7 19l9-9z"/></svg></div>',
    responsive: [
      {
        breakpoint: 1350,
        settings: {
          centerPadding: '100px', 
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          centerPadding: '70px', 
          slidesToShow: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          infinite: false,
          centerMode: false,
          centerPadding: '0px', 
          slidesToShow: 1,
        }
      }
    ]
  });
}

// Initial call
initTestimonialSlider();

// Re-init when section is loaded or changed in Shopify customizer
if (Shopify.designMode) {
  $(document).on('shopify:section:load shopify:section:reorder shopify:section:select shopify:block:select', function() {
    initTestimonialSlider();
  });
}
